import { Box, Card, CardContent, Typography } from "@mui/material";
import { Stack } from "@mui/system";

interface GetStartedStepProps {
  caption: string;
  title: string;
  description: string;
  actions: React.ReactNode;
}

const GetStartedStep = ({ caption, title, description, actions }: GetStartedStepProps) => (
  <Card sx={{ width: "100%", borderRadius: "8px" }}>
    <CardContent sx={{ padding: 3, height: "100%", display: "flex", flexDirection: "column" }}>
      <Stack gap={"4px"} height={"100%"}>
        <Stack>
          <Typography variant="caption" color="textSecondary">
            {caption}
          </Typography>
          <Typography variant="subtitle1" fontWeight={500}>
            {title}
          </Typography>
        </Stack>
        <Stack spacing={2} flexGrow={1}>
          <Typography variant="body2" color="textSecondary">
            {description}
          </Typography>
          <Stack direction="row" spacing={2} height="100%">
            <Box width="100%" alignContent="flex-end">
              {actions}
            </Box>
          </Stack>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);

export default GetStartedStep;
